class CupomKitUpsell extends HTMLElement {
  constructor() {
    super();

    // Mantém estrutura / seletores por compatibilidade
    this.message = this.querySelector("p.message");
    this.discountedPrice = this.querySelector(".discounted-price");
  }
}

customElements.define("cupom-kits-upsell", CupomKitUpsell);